import type { ReactNode } from 'react';

type ToolNoticeKind = 'info' | 'privacy' | 'warning' | 'danger';

export interface ToolNoticeProps {
  kind?: ToolNoticeKind;
  title?: string;
  children: ReactNode;
  className?: string;
}

export function ToolNotice({ kind = 'info', title, children, className }: ToolNoticeProps) {
  const role = kind === 'danger' ? 'alert' : 'status';
  return (
    <div
      className={['tool-notice', `tool-notice--${kind}`, className ?? ''].filter(Boolean).join(' ')}
      role={role}
    >
      {title ? <strong className="tool-notice__title">{title}</strong> : null}
      <div className="tool-notice__content">{children}</div>
    </div>
  );
}
